import { runInAction, makeAutoObservable, action } from 'mobx';
import { Permission, PermissionProps } from '@ixicare/resources';
import { State } from '~/store/types';

class PermissionsStore {
  rootStore: State;
  permissionLists: PermissionProps[] = [];
  loaded: boolean = false;

  constructor(rootStore: State) {
    makeAutoObservable(this, {
      rootStore: false,
      loadPermissions: action.bound,
      clear: action.bound,
    });
    this.rootStore = rootStore;
  }

  has(name: string): boolean {
    if (!this.loaded) return false;
    return this.permissionLists.some((list) =>
      list.entries.some((entry) => entry.permission.name === name && entry.isEnabled)
    );
  }

  loadPermissions(): Promise<void> {
    return Permission.getOwnPermissions()
      .then((permissionLists) => {
        runInAction(() => {
          this.permissionLists = permissionLists;
          this.loaded = true;
        });
      })
      .catch((e) => {
        console.error('loadPermissions failed', e);
        runInAction(() => {
          this.permissionLists = [];
          this.loaded = true;
        });
      });
  }

  clear() {
    this.permissionLists = [];
    this.loaded = false;
  }
}

export default PermissionsStore;
